import ApiService from "../../ApiService";

const HomeworkService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/mobile/homework/unit/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    replyUnit: (userHomeworkUnitId, successCallback, failureCallback) => {
        ApiService.post("/mobile/homework/unit/replyunit", { userHomeworkUnitId }, successCallback, failureCallback);
    },
};

export default HomeworkService;
